"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Hack to workaround this issue:
// https://github.com/Microsoft/TypeScript/issues/12870
// eslint-disable-next-line no-use-before-define
var getKeys = Object.keys;
var _default = getKeys;
exports.default = _default;